import React, { useEffect, useState, useCallback } from "react"
import Post from "../Post/Post"
import useDeviceType from "../hooks/Utils/useDeviceType"
import TopSkills from "../TopSkills/TopSkills"
import { throttle } from "lodash"
import styles from "./Home.module.css"
import Spinner from "../UI/Spinner/Spinner"
import Instructions from "../Instructions/Instructions"
import { useApiService } from "../hooks/Api/useApiService"
const ForYou = React.lazy(() => import("../ForYou/ForYou"))
const TopUsers = React.lazy(() => import("../TopUsers/TopUsers"))
const Feed = React.lazy(() => import("../Feed/Feed"))
const Profile = React.lazy(() => import("../Profile/ProfileCard"))

const HomePage = () => {
  const deviceType = useDeviceType()
  const isDesktop = deviceType === "desktop"
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const [showInstructions, setShowInstructions] = useState(false)
  const { postData } = useApiService()

  useEffect(() => {
    postData("users/getuser", { user_name: localStorage.getItem("user") }).then((data) => {
      setShowInstructions(!data?.user[0].seen_instructions)
    })
  }, [showInstructions])

  const handleScroll = useCallback(
    throttle(() => {
      const scrollTop = window.pageYOffset
      const windowHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight
      const totalScrollableHeight = docHeight - windowHeight
      const scrollPercent = (scrollTop || 0 / totalScrollableHeight) * 100
      setScrollPercentage(scrollPercent)
    }, 100),
    []
  )

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [handleScroll])

  const handleFinishInstructions = () => {
    postData("users/seeninstructions", { user_name: localStorage.getItem("user") }).then(
      (data) => {}
    )
    setShowInstructions(false)
  }

  return (
    <>
      <div className={styles.home_container}>
        {showInstructions && <Instructions onFinish={handleFinishInstructions} />}
        {isDesktop && (
          <div className={styles.profile_users_container}>
            <React.Suspense fallback={<Spinner />}>
              <Profile editable={false} user_name={localStorage.getItem("user")} />
            </React.Suspense>
            <React.Suspense fallback={<Spinner />}>
              <TopUsers />
            </React.Suspense>
          </div>
        )}

        <div
          className={
            isDesktop ? styles.post_feed_container_desktop : styles.post_feed_container_mobile
          }
        >
          <Post page={"home"} />
          <React.Suspense fallback={<Spinner />}>
            <ForYou />
          </React.Suspense>

          <React.Suspense fallback={<Spinner />}>
            <Feed scrollPercentage={scrollPercentage} />
          </React.Suspense>
        </div>

        {isDesktop && (
          <React.Suspense fallback={<Spinner />}>
            <TopSkills />
          </React.Suspense>
        )}
        {/* 
        <Messanging /> */}
      </div>
    </>
  )
}

export default HomePage
